import React from "react";

import { CompassParagraph } from "../../components/common/styledComponents";
import { FlexibleContainer } from "../../components/containers/styledComponents";
import { greyText } from "../../styles";
import { StyledPlaceholder } from "../../components/visuals/styledComponents";

export const CompanyDescription = ({
  description,
}: CompanyDescriptionProps): JSX.Element => {
  return (
    <FlexibleContainer p={"20px 25px"} ai="flex-start" fd="column">
      {description ? (
        <CompassParagraph color={greyText} ta="justify">
          {description}
        </CompassParagraph>
      ) : (
        <>
          <StyledPlaceholder xs={6} size="lg" bg="white" mb={20} ml={-10} />
          <StyledPlaceholder xs={12} size="lg" bg="white" ml={-10} />
          <StyledPlaceholder xs={12} size="lg" bg="white" mb={1} ml={-10} />
        </>
      )}
    </FlexibleContainer>
  );
};

export type CompanyDescriptionProps = {
  description: string | null;
};
